import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import ViewQuiltRoundedIcon from "@mui/icons-material/ViewQuiltRounded";
import CloudRoundedIcon from "@mui/icons-material/CloudRounded";
import RouteRoundedIcon from "@mui/icons-material/RouteRounded";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import { useNavigate } from "react-router-dom";

const items = [
  {
    icon: <ViewQuiltRoundedIcon />,
    title: "Custom Software Development",
    description:
      "Tailored solutions crafted to meet specific needs, enhancing efficiency, productivity, and competitiveness for businesses.",
    // tools: ["Development", "Deployment"],
  },
  {
    icon: <CloudRoundedIcon />,
    title: "Cloud Solutions",
    description:
      " Innovative cloud-based services enabling scalable, flexible, and accessible solutions for modern businesses and organizations.",
    // tools: ["AWS", "GCP"],
  },
  {
    icon: <RouteRoundedIcon />,
    title: "Third Party integration",
    description:
      "Seamless integration solutions connecting your software with third-party tools, enhancing functionality and efficiency across platforms.",
  },
  {
    icon: <ConstructionRoundedIcon />,
    title: "Software maintainance and support",
    description:
      "Ensure seamless operations and updates, resolving issues promptly to optimize software performance and ensure client satisfaction.",
  },
];

export const Services = () => {
  const [selectedItemIndex, setSelectedItemIndex] = React.useState(0);

  const handleItemClick = (index) => {
    setSelectedItemIndex(index);
  };

  const navigate = useNavigate();

  return (
    <Container
      data-aos="fade-up"
      data-aos-duration="2000"
      id="services"
      sx={{
        pt: { xs: 4, sm: 2 },
        pb: { xs: 8, sm: 10 },
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Box
        sx={{
          width: { sm: "100%", md: "60%" },
          textAlign: { sm: "left", md: "center" },
        }}
      >
        <div>
          <Typography
            component="h2"
            variant="h4"
            color="text.primary"
            fontWeight="bold"
            sx={{ lineHeight: { xs: "2.5rem" }, mt: 2, mb: 2 }}
          >
            Services
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: { xs: 2, sm: 4 } }}
          >
            We create exceptional products with end-to-end support and expert
            guidance.
          </Typography>
        </div>
      </Box>
      <Grid container spacing={4}>
        {items.map(({ icon, title, description, tools }, index) => (
          <Grid item key={index} sx={{ display: "flex" }} xs={12} md={6}>
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="flex-start"
              spacing={2}
              useFlexGap
              sx={{
                width: "100%",
                display: "flex",
              }}
            >
              <Card
                key={index}
                variant="outlined"
                component={Button}
                onClick={() => handleItemClick(index)}
                sx={{
                  p: 3,
                  height: "fit-content",
                  width: "200%",
                  background: "none",
                  backgroundColor:
                    selectedItemIndex === index ? "action.selected" : undefined,
                  borderColor: (theme) => {
                    if (theme.palette.mode === "light") {
                      return selectedItemIndex === index
                        ? "primary.light"
                        : "grey.200";
                    }
                    return selectedItemIndex === index
                      ? "primary.dark"
                      : "grey.800";
                  },
                }}
              >
                <Box
                  mt={2}
                  sx={{
                    width: "100%",
                    display: "flex",
                    textAlign: "left",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: { md: "center" },
                    gap: 2.5,
                  }}
                >
                  <Box
                    sx={{
                      color: (theme) => {
                        if (theme.palette.mode === "light") {
                          return selectedItemIndex === index
                            ? "primary.main"
                            : "grey.300";
                        }
                        return selectedItemIndex === index
                          ? "primary.main"
                          : "grey.700";
                      },
                    }}
                  >
                    {icon}
                  </Box>
                  <Box sx={{ textTransform: "none" }}>
                    <Typography
                      color="text.primary"
                      variant="body2"
                      fontWeight="bold"
                    >
                      {title}
                    </Typography>
                    <Typography
                      color="text.secondary"
                      variant="body2"
                      sx={{ my: 0.5 }}
                    >
                      {description}
                    </Typography>

                    <Typography display="flex" justifyContent="space-between">
                      <Stack direction="row" spacing={1} mt={3}>
                        {tools?.map((item, i) => (
                          <Chip key={i} label={item} />
                        ))}
                      </Stack>

                      <Link
                        color="primary"
                        variant="body2"
                        fontWeight="bold"
                        onClick={() => navigate("/services")}
                        mt={3}
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          "& > svg": { transition: "0.2s" },
                          "&:hover > svg": { transform: "translateX(2px)" },
                        }}
                      >
                        <span>Learn more</span>
                        <ChevronRightRoundedIcon
                          fontSize="small"
                          sx={{ mt: "1px", ml: "2px" }}
                        />
                      </Link>
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};
